import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { SetStatusToneRequest } from './setstatustonepricerequest';

export class SetStatusToneAPI extends SixdeeCRBTAPI<SetStatusToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-tone-price
        return "status-pack-activation";
    }

    getRequestData()
    {

        return "clientTxnId=1710219007"+"&"+
               "language="+ (this.getRequest().getSetStatusToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
               "serviceId=6"+ "&"+
               "aPartyMsisdn="+ this.getRequest().getSetStatusToneRequest().getMsisdn()+"&"+
               "packName="+ this.getRequest().getSetStatusToneRequest().getPackName()+"&"+
               "toneId="+ this.getRequest().getSetStatusToneRequest().getToneId()+"&"+
               "startDate="+ this.getRequest().getSetStatusToneRequest().getStartDate()+"&"+
               "endDate="+ this.getRequest().getSetStatusToneRequest().getEndDate()+"&"+
               "startTime="+ this.getRequest().getSetStatusToneRequest().getStartTime()+"&"+
               "endDTime="+ this.getRequest().getSetStatusToneRequest().getEndTime()+
               "&"+"channel="+ this.getRequest().getSetStatusToneRequest().getChannel();

        /* return "clientTxnId=1710219007"+"&"+
               "language="+ (this.getRequest().getSetStatusToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
               "serviceId=6"+ "&"+
               "aPartyMsisdn="+ this.getRequest().getSetStatusToneRequest().getMsisdn()+"&"+
               "toneId="+ this.getRequest().getSetStatusToneRequest().getToneId()+"&"+
               "startDate="+ this.getRequest().getSetStatusToneRequest().getToneId()+"&"+
               "endDate="+ this.getRequest().getSetStatusToneRequest().getToneId()+"&"+
               "startTime="+ this.getRequest().getSetStatusToneRequest().getToneId()+"&"+
               "endDTime="+ this.getRequest().getSetStatusToneRequest().getToneId()+"&"+
               "channelId=9"; */
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/statustune/setstatustune/setstatustoneapi.tsx